import styled from "styled-components";

import Background from '../../../../assets/images/banners/banner_site2.png';

export const BaseComp = styled.div`
    display: flex;
    background-image: url(${Background});;
    padding: 5%;
    @media only screen and (max-width: 800px) {
        flex-direction: column;
    }

`;

export const BaseContent = styled.div`
    display: flex;
    width: 100%;
    margin: 0% 20%;
    flex-direction: column;
    @media (max-width: 1000px) {
        margin: 0% 1%;
    }
`;

export const TextContent = styled.div`
    color: var(--var(--purple-bhbusmidia));
    text-align: center;
`;

export const TextTitle = styled.div`
    h1 {
        font-size: 36px;
    }
    h2 {
        font-weight: normal;
    }
`;

export const TextBody = styled.div`
    font-size: 24px;
    p {
        margin-top: 3%;
    }
`;

export const IconsContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5%;
    @media only screen and (max-width: 800px) {
        flex-direction: column;
    }
`;

export const DefaultBox = styled.div`
    background-color: var(--purple-lightdark);
    width: 220px;
    height: 220px;
    margin: 10px;
    color: white;
    h1 {
        color: white;
    }
    padding: 1% 2%;
    border-radius: 16px;
    justify-content: center;
    text-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const IconImg = styled.img`
    width: auto;
    height: 60px;
`;
export const IconImgMulti = styled.img`
    width: auto;
    height: 60px;
`;